import { ResourceType } from 'Enums/ResourceType';
import { ResourceIcon } from 'Enums/ResourceTypeIcons';

export const GetResourceTypeIcon = (resourceTypeID: number) =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  ResourceIcon[ResourceType[resourceTypeID]];
